import axios from '@/http/index';

const base = '';
// 获得会员卡相关信息
export const getMemberCardMsg = (params) => axios.get(`${base}/erp/member/getMemberCardMsg`, params).then((res) => res.data);
// 套餐购买订单支付
export const postPayOrder = (params) => axios.post(`${base}/erp/package/payOrder`, params).then((res) => res.data);
// 获取能出售的卡券信息
export const getSaleCardList = (params) => axios.get(`${base}/erp/package/getSaleCardList`, params).then((res) => res.data);
// 获取扫码支付二维码
export const getScanPayQRCode = (params) => axios.get(`${base}/erp/package/getScanPayQRCode`, params).then((res) => res.data);
// 获得扫码支付状态
export const getScanPayStatus = (params) => axios.get(`${base}/erp/package/getScanPayStatus`, params).then((res) => res.data);
// 打印订单
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);
// 是否设置了打印机
export const hasPrintSet = (params) => axios.get(`${base}/erp/print/hasPrintSet`, params).then((res) => res.data);
